import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IKundenGruppesQueryShapes, KundenGruppesQueryFilterConfig } from 'fa-kt.types';
import { KundenGruppesService } from '../service';

@Component({
  selector: 'fa-kt-kunden-gruppes-filter',
  templateUrl: './kunden-gruppes-filter.component.html',
  styleUrls: ['./kunden-gruppes-filter.component.css'],
})
export class KundenGruppesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  KundenGruppesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kundenGruppes: KundenGruppesService,
  ) {
    this.KundenGruppesFilterConfig = KundenGruppesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.kundenGruppes.shapes$.subscribe((shapes: IKundenGruppesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.KundenGruppesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.KundenGruppesFilterConfig[index].selections = shapes;
  }
}
